var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.99997V7C6 5.4087 6.63214 3.88257 7.75732 2.75736C8.88255 1.63214 10.4087 1 12 1C13.5913 1 15.1175 1.63214 16.2427 2.75736C17.3678 3.88257 18 5.4087 18 7V7.99997H20C20.2652 7.99997 20.5196 8.10534 20.7071 8.29292C20.8946 8.48042 21 8.73482 21 9.00002V21C21 21.2652 20.8946 21.5195 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5195 3 21.2652 3 21V9.00002C3 8.73482 3.10536 8.48042 3.29289 8.29292C3.48043 8.10534 3.73478 7.99997 4 7.99997H6ZM19 9.99999H5V20H19V9.99999ZM11 15.732C10.6187 15.5119 10.3207 15.1721 10.1522 14.7653C9.98377 14.3585 9.95423 13.9076 10.0682 13.4823C10.1821 13.0571 10.4332 12.6812 10.7825 12.4133C11.1318 12.1452 11.5597 11.9999 12 11.9999C12.4403 11.9999 12.8682 12.1452 13.2175 12.4133C13.5668 12.6812 13.8179 13.0571 13.9318 13.4823C14.0458 13.9076 14.0162 14.3585 13.8478 14.7653C13.6792 15.1721 13.3813 15.5119 13 15.732V18H11V15.732ZM8.00003 7.99997H16V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92175 3.42143 9.1716 4.17157C8.42145 4.92172 8.00003 5.93913 8.00003 7V7.99997Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock3);
export default __webpack_public_path__ + "static/media/lock-3.f4002b77bf407f34e6382def4b651f52.svg";
export { ForwardRef as ReactComponent };